import React from "react";
import {
  FaCalendarCheck,
  FaCalendarTimes,
  FaCreditCard,
  FaEye,
  FaTrash,
} from "react-icons/fa";

import {
  formatCurrency,
  formatDateFr,
  getRenewalMessage,
  getRenewalStatusLabel,
  getRenewalStatusStyle,
  getSubscriptionAmount,
  getSubscriptionExpiryDate,
  getSubscriptionFormula,
  getSubscriptionPurchaseDate,
  getSubscriptionUserEmail,
  getSubscriptionUserName,
} from "../utils/adminSubscriptionsUtils";

function SubscriptionsMobileList({ subscriptions = [], onOpen, onDelete }) {
  return (
    <section className="space-y-3 lg:hidden">
      {subscriptions.map((subscription) => (
        <article
          key={subscription.id}
          className="rounded-[1.75rem] border border-slate-200 bg-white p-4 shadow-lg shadow-slate-200/50 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20"
        >
          <div className="flex items-start gap-3">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-700 to-sky-600 text-white">
              <FaCreditCard />
            </div>

            <div className="min-w-0 flex-1">
              <p className="font-bold text-slate-950 dark:text-white">
                {getSubscriptionUserName(subscription)}
              </p>

              <p className="mt-1 truncate text-xs font-semibold text-slate-400">
                {getSubscriptionUserEmail(subscription)}
              </p>

              <p className="mt-2 text-sm font-bold text-slate-700 dark:text-white/80">
                {getSubscriptionFormula(subscription)}
              </p>

              <div className="mt-3 flex flex-wrap gap-2">
                <span
                  className={`inline-flex min-h-8 items-center rounded-2xl px-3 text-xs font-bold ${getRenewalStatusStyle(
                    subscription,
                  )}`}
                >
                  {getRenewalStatusLabel(subscription)}
                </span>

                <span className="inline-flex min-h-8 items-center rounded-2xl bg-slate-100 px-3 text-xs font-bold text-slate-600 dark:bg-white/10 dark:text-white/70">
                  {formatCurrency(getSubscriptionAmount(subscription))}
                </span>
              </div>
            </div>
          </div>

          <div className="mt-4 grid gap-2 rounded-2xl bg-slate-50 p-3 text-xs font-bold text-slate-500 dark:bg-slate-950 dark:text-white/50">
            <p className="flex items-center gap-2">
              <FaCalendarCheck className="text-slate-300" />
              Achat : {formatDateFr(getSubscriptionPurchaseDate(subscription))}
            </p>

            <p className="flex items-center gap-2">
              <FaCalendarTimes className="text-slate-300" />
              Échéance : {formatDateFr(getSubscriptionExpiryDate(subscription))}
            </p>

            <p>{getRenewalMessage(subscription)}</p>
          </div>

          <div className="mt-4 grid gap-2 sm:grid-cols-2">
            <button
              type="button"
              onClick={() => onOpen(subscription)}
              className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl bg-blue-700 px-4 py-2 text-xs font-bold text-white transition hover:-translate-y-0.5 hover:bg-blue-800"
            >
              <FaEye />
              Voir l’abonnement
            </button>

            <button
              type="button"
              onClick={() => onDelete(subscription.id)}
              className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-2xl border border-red-200 bg-red-50 px-4 py-2 text-xs font-bold text-red-700 transition hover:-translate-y-0.5 hover:bg-red-100 dark:border-red-500/20 dark:bg-red-500/10 dark:text-red-200"
            >
              <FaTrash />
              Supprimer
            </button>
          </div>
        </article>
      ))}
    </section>
  );
}

export default SubscriptionsMobileList;